import { z } from "zod";

import { filter } from "~/tools/filter";
import { isPresent } from "~/tools/is-present";
import { piped } from "~/tools/piped";
import { prop } from "~/tools/prop";
import { sortBy } from "~/tools/sort-by";

import { WidgetThresholdsStep } from "../../components/widget-form/thresholds/form-state";

const dashboardWidgetThreshold = z.object({
	color: z.string().trim(),
	value: z.number().catch(WidgetThresholdsStep.fallback.value),
});

export type DashboardWidgetThreshold = z.infer<typeof dashboardWidgetThreshold>;

export const dashboardWidgetThresholds = z
	.array(dashboardWidgetThreshold.optional().catch(undefined))
	.catch([])
	.transform(piped(filter(isPresent), sortBy([prop("value"), "desc"])));
